import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'components/shared/dropdown/Dropdown';
import { QualificationTypeEnum } from 'domain/qualification-type-enum';
import SearchableDropDown from 'components/shared/dropdown/SearchableDropDown';
import './NewQualificationForm.css';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import addPng from 'images/add.png';
import removePng from 'images/remove.png';
import Input from 'components/shared/input/Input';

class NewQualificationForm extends Component {
  static propTypes = {
    trades: PropTypes.array,
    types: PropTypes.arrayOf(PropTypes.instanceOf(QualificationTypeEnum)),
    loadLabelOptions: PropTypes.func.isRequired,
    onQualificationCreated: PropTypes.func,
    onQualificationSelected: PropTypes.func,
  };

  static defaultProps = {
    labelOptions: [],
    trades: [],
    types: [
      QualificationTypeEnum.GENERAL,
      QualificationTypeEnum.TRADE,
      QualificationTypeEnum.OTHER,
    ],
  };

  constructor(props) {
    super(props);
    this.state = {
      newOption: '',
      options: [],
      selectedLabel: null, // option type { value, label }
      selectedTrade: null,
      selectedType: null,
      showConfirmation: false,
    };
  }

  render() {
    return (
      <div className="new-qualification-form">
        <table>
          <tbody>
            <tr>
              <td>Type</td>
              <td>
                <Dropdown
                  className="new-qualification-dropdown"
                  options={this.props.types.map((type) => {
                    return {
                      value: type.id,
                      label: type.label,
                    };
                  })}
                  placeholder="Select type"
                  value={this.state.selectedType}
                  onChange={this.handleTypeChange}
                />
              </td>
            </tr>
            {this.state.selectedType !== null && this.state.selectedType === 2 && (
              <tr>
                <td>Trade</td>
                <td>
                  <Dropdown
                    className="new-qualification-dropdown"
                    options={this.props.trades.map((trade) => {
                      return {
                        value: trade.id,
                        label: trade.label,
                      };
                    })}
                    placeholder="Select trade"
                    value={this.state.selectedTrade}
                    onChange={this.handleTradeChange}
                  />
                </td>
              </tr>
            )}
            {this.state.selectedType !== null &&
              (this.state.selectedType !== QualificationTypeEnum.TRADE.id ||
                (this.state.selectedType === QualificationTypeEnum.TRADE.id &&
                  this.state.selectedTrade !== null)) && (
                <tr>
                  <td>Label</td>
                  <td>
                    <SearchableDropDown
                      autoload={false}
                      cache={false}
                      className="new-qualification-dropdown"
                      clearable={true}
                      creatable={true}
                      loadOptions={this.handleLoadLabelOptions.bind(this)}
                      newOptionCreator={(option) => {
                        return { value: 0, label: option.label };
                      }}
                      placeholder="Enter label"
                      promptTextCreator={(label) => {
                        return `Create label ${label}`;
                      }}
                      value={this.state.selectedLabel}
                      onChange={this.handleLabelChange}
                    />
                  </td>
                </tr>
              )}
            {this.state.selectedLabel !== null &&
              this.state.selectedLabel.value === 0 && (
                <tr>
                  <td>Options</td>
                  <td>
                    <div className="options-container">
                      <div>
                        <Input
                          placeholder="Enter new option"
                          value={this.state.newOption}
                          onChange={this.handleNewOptionChange}
                        />
                        {this.state.newOption !== '' && (
                          <img
                            src={addPng}
                            alt="add"
                            onClick={this.handleOptionAdd}
                          />
                        )}
                      </div>
                      <div>
                        <ul>
                          {this.state.options.map((option, index) => {
                            return (
                              <li key={index}>
                                <span>{option}</span>
                                <img
                                  src={removePng}
                                  alt="remove"
                                  onClick={this.handleOptionRemove.bind(
                                    this,
                                    index
                                  )}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            <tr>
              <td>
                <input
                  type="button"
                  className="btn button button-orange"
                  value="Create"
                  disabled={!this.enableAddButton()}
                  onClick={this.handleAdd}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <ConfirmationModal
          show={this.state.showConfirmation}
          message="Do you want to use this qualification?"
          onHide={this.handleConfirmation}
        />
      </div>
    );
  }

  handleTypeChange = (option) => {
    this.setState({
      selectedTrade: null, // update in case type is changed
      selectedType: option.value,
    });
  };

  handleTradeChange = (option) => {
    this.setState({
      selectedTrade: option.value,
    });
  };

  handleLoadLabelOptions = (input) => {
    return this.props.loadLabelOptions(
      input,
      this.state.selectedType,
      this.state.selectedTrade
    );
  };

  handleLabelChange = (option) => {
    this.setState({
      selectedLabel: option,
      showConfirmation: option !== null && option.value !== 0,
    });
  };

  handleConfirmation = (result) => {
    this.setState({
      showConfirmation: false,
    });
    if (result) {
      if (this.props.onQualificationSelected !== undefined) {
        // Send object
        this.props.onQualificationSelected(
          this.state.selectedLabel.qualification
        );
      }
    } else {
      this.setState({
        selectedLabel: null,
      });
    }
  };

  handleNewOptionChange = (value) => {
    this.setState({
      newOption: value,
    });
  };

  handleOptionAdd = (event) => {
    event.preventDefault();
    this.setState({
      newOption: '',
      options: this.state.options.concat([this.state.newOption]),
    });
  };

  handleOptionRemove = (optionIndex, event) => {
    event.preventDefault();
    this.setState({
      options: this.state.options.filter(
        (option, index) => index !== optionIndex
      ),
    });
  };

  enableAddButton = () => {
    let result = this.state.selectedType !== null;
    if (this.state.selectedType === 2) {
      // Trade
      result = result && this.state.selectedTrade !== null;
    }
    result = result && this.state.selectedLabel !== null;

    return result;
  };

  handleAdd = (event) => {
    event.preventDefault();
    if (this.props.onQualificationCreated) {
      this.props.onQualificationCreated({
        type: QualificationTypeEnum.getById(this.state.selectedType).value, // send value, selectedType is array index
        trade: this.state.selectedTrade,
        label: this.state.selectedLabel.label,
        options: this.state.options,
      });
    }
  };
}

export default NewQualificationForm;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/qualifications/NewQualificationForm.js